import { render, staticRenderFns } from "./StatisticsRequisitesUsers.vue?vue&type=template&id=14a2d772&scoped=true&"
import script from "./StatisticsRequisitesUsers.vue?vue&type=script&lang=js&"
export * from "./StatisticsRequisitesUsers.vue?vue&type=script&lang=js&"
import style0 from "./StatisticsRequisitesUsers.vue?vue&type=style&index=0&id=14a2d772&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14a2d772",
  null
  
)

export default component.exports